import React from 'react'
import Brand from "./Brand";
import DevSkills from './DevSkills';
import Experience from './Experience';
import Facts from './Facts'
import LanguajeSkills from './LanguageSkills';

const ModalContent = ({ toggleModal }) => {
    return ( 
        <div className="tokyo_tm_modalbox_about">

          <button className="close-modal" onClick={toggleModal}>
            <img src="assets/img/svg/cancel.svg" alt="close icon" />
          </button>
          
          <div className="box-inner">
            <div className="description_wrap scrollable">
              <div className="my_box">
                  
                <DevSkills />

                <LanguajeSkills />

              </div>

              <Facts />

              <Experience />
              
              <div className="partners">
                
                <div className="about_title">
                  <h3>Our Partners</h3>
                </div>

                <Brand />

              </div>
              {/* END PARTNER SLIDER */}
            </div>
          </div>
        </div>
    );
}
 
export default ModalContent;